// Must run before anything else evaluates (incl. pdfjs on the main thread).
import './polyfills';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { theme } from './config';
import ApplicationError from './components/global/ApplicationError/ApplicationError';
import ErrorBoundary from './components/global/ErrorBoundary/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { initErrorReporter } from './services/errorReporter';

import './i18n';

import './fonts/fonts.css';
import './common.scss';

initErrorReporter();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element with id "root" was not found.');
}

const root = createRoot(rootElement);

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <ErrorBoundary fallback={<ApplicationError />}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </ThemeProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
